import { IS_IOS, IS_QQ, IS_WECHAT } from '../util/ua';
import { getMqqApi, getWxBridge } from './bridge';

export interface CheckOptions{
  /**
	 * android使用 packageName
	 */
  packageName: string;
  /**
	 * ios模式下使用 packageUrl
	 */
  packageUrl: string;
  /**
   * 检测超时时间，默认6000
   */
  checkTimeout?: number;
}

export function checkAppInstalledInWx(checkOpts: CheckOptions): Promise<boolean> {
  if (!IS_WECHAT) {
    return Promise.resolve(false);
  }
  return new Promise(async (resolve) => {
    const bridge = await getWxBridge();
    bridge?.invoke('getInstallState', {
      packageUrl: checkOpts.packageUrl,
      packageName: checkOpts.packageName,
    }, (res) => {
      if ((res.err_msg as string).indexOf('yes') !== -1) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
    setTimeout(() => {
      resolve(false);
    }, checkOpts.checkTimeout ?? 6000);
  });
}

/**
 * 在QQ环境下检测app是否拉起
 */
export function checkAppInstalledInQQ(checkOpts: CheckOptions): Promise<boolean> {
  if (!IS_QQ) {
    return Promise.resolve(false);
  }
  return new Promise(async (resolve) => {
    const mqq = await getMqqApi();
    // ios中使用scheme，android使用包名
    mqq?.invoke('app', 'isAppInstalled',  IS_IOS ? checkOpts.packageUrl : checkOpts.packageName, (result) => {
      // ios的返回值是一个对象，android的返回值是一个boolean
      const isInstalled: boolean = typeof result === 'boolean' ? result : result.result;
      resolve(isInstalled);
    });
    setTimeout(() => {
      resolve(false);
    }, checkOpts.checkTimeout ?? 6000);
  });
}
